import { type PrimitiveProps } from '@react-three/fiber';
import { type MacbookProModel, GLTFModel } from '@billykwok/3d';

import { AnimatedPrimitive } from '@/utils/react-three-fiber/animations';
import { useGLTF } from '@/utils/react-three-fiber/useGLTF';

const modelPath = `/models/${GLTFModel.MacbookPro}`;

export function AnimatedMacbookPro(props: Partial<PrimitiveProps>) {
  const { scene } = useGLTF<MacbookProModel, string>(modelPath);
  return <AnimatedPrimitive object={scene} dispose={null} {...props} />;
}

useGLTF.preload(modelPath);
